import React from "react";

import HeadTitle from "components/HeadTitle";
import Header from "components/ForCreators/Header";
import CookBook from "components/ForCreators/CookBook";
import Platform from "components/ForCreators/Platform";
import Chart from "components/ForCreators/Chart";
import Discover from "components/ForCreators/Discover";
import Additional from "components/ForCreators/Additional";
import Join from "components/ForCreators/Join";
import Recipes from "components/ForCreators/Recipes";
import FAQ from "components/ForCreators/FAQ";
import { GridColumn } from "emotion-flex-grid";
import { ContainerFull, Row } from "../../styles/General.styled";
import { ContentFull } from "../../styles/App.styled";
import { useSelector } from "react-redux";
import Router from "next/router";
import { isUserLogin } from "store/loginReducer";
import { getOwner } from "store/userReducer/userSelectors";

const ForCreators = () => {
  const isLogin = useSelector(isUserLogin);
  const currentUser = useSelector(getOwner);

  const becomeCreator = () => {
    if (!isLogin) {
      Router.push("/registration");
    }
    if (isLogin && !currentUser.is_creator) {
      Router.push({
        pathname: "/settings",
        query: { becomeCreator: true },
      });
    }
  };

  return (
    <>
      <HeadTitle title="Foody | For creators" />
      <ContainerFull>
        <GridColumn pt={["s", "xl1"]} pb={["xl2", "xxl21"]}>
          <Row>
            <ContentFull>
              <Header isLogin={isLogin} isCreator={currentUser.is_creator} becomeCreator={becomeCreator} />
              <CookBook />
              <Platform />
              <Chart isLogin={isLogin} isCreator={currentUser.is_creator} becomeCreator={becomeCreator} />
              <Discover />
              <Additional />
              <Recipes />
              {(!isLogin || !currentUser.is_creator) && (
                <Join isLogin={isLogin} isCreator={currentUser.is_creator} becomeCreator={becomeCreator} />
              )}
              <FAQ />
            </ContentFull>
          </Row>
        </GridColumn>
      </ContainerFull>
    </>
  );
};

export default ForCreators;
